import { createSlice } from "@reduxjs/toolkit";

import {
  //getObjectives,
  addObjectives,
  updateObjectives,
  deleteObjectives,
  getObjectivesByProject,
} from "./thunk";

interface ObjectivesStateType {
  objectives: Array<any>;
  error?: string | object | null | undefined | unknown;
  success?: string | object | null | undefined | unknown;
}

export const initialState: ObjectivesStateType = {
  objectives: [],
  error: null,
  success: null,
};

const objectivesSlice = createSlice({
  name: "objectives",
  initialState,
  reducers: {
    objectivesError(state, action) {
      state.error = action.payload;
    },
    objectivesSuccess(state, action) {
      state.success = action.payload;
    },
  },
  extraReducers: builder => {
    /*builder.addCase(getObjectives.fulfilled, (state: any, action: any) => {
      state.objectives = action.payload;
    });
    builder.addCase(getObjectives.rejected, (state, action) => {
      state.error = action.payload || null;
    });*/
    builder.addCase(addObjectives.fulfilled, (state: any, action: any) => {
      state.objectives.push(action.payload);
    });
    builder.addCase(addObjectives.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(updateObjectives.fulfilled, (state: any, action: any) => {
      state.objectives = state.objectives.map((objectives: any) =>
        objectives.id === action.payload.id
          ? { ...objectives, ...action.payload }
          : objectives
      );
    });
    builder.addCase(updateObjectives.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(deleteObjectives.fulfilled, (state: any, action: any) => {
      state.objectives = state.objectives.filter(
        (objectives: any) => objectives.id !== action.payload
      );
    });
    builder.addCase(deleteObjectives.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(
      getObjectivesByProject.fulfilled,
      (state: any, action: any) => {
        state.objectives = action.payload;
      }
    );
    builder.addCase(getObjectivesByProject.rejected, (state, action) => {
      state.error = action.payload || null;
    });
  },
});

export const { objectivesError, objectivesSuccess } = objectivesSlice.actions;

export default objectivesSlice.reducer;
